import React, { useEffect, useRef } from "react";

import { motion, useScroll } from "framer-motion";

export default function contact() {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });
  // IOS Autoplay workaround
  useEffect(() => {
    window.addEventListener(
      "touchstart",
      function () {
        var heroVideo = document.getElementById("heroVideo");
        heroVideo.play();
      },
      { once: true }
    );
  }, []);

  return (
    <div ref={containerRef} id="hero" className="relative">
      <motion.div
        className={`h-screen w-screen absolute -z-10 bg-black bg-opacity-40 animate-fadeDown`}
      ></motion.div>
      {/* <div className={`h-screen w-screen absolute -z-10 bg-gradient-to-${overlayStyle.substring(0, 1)} from-transparent to-black/${overlayOpacity}`}></div> */}

      <motion.div className="h-screen w-screen absolute overflow-hidden object-cover -z-20 animate-fadeDown">
        <video
          id="heroVideo"
          className={
            "h-screen w-screen absolute overflow-hidden object-cover -z-20"
          }
          autoPlay={true}
          muted={true}
          loop={true}
          playsInline={true}
        >
          {/* <source src={'hero.mp4'} /> */}
          <source
            src={
              "https://res.cloudinary.com/dntwnklls/video/upload/f_auto:video,q_auto/v1/rizz-website/hero-2"
            }
          />
          {/* <source src={'https://res.cloudinary.com/dntwnklls/video/upload/f_auto:video,q_auto/v1/rizz-website/hero'} /> */}
        </video>
      </motion.div>
      <div className="h-screen w-screen flex flex-col-reverse">
        <div className="animate-fadeUp container mt-16 md:mt-0 pt-10 pb-24 sm:pb-32 flex flex-col md:flex-row space-y-4 md:space-y-0 md:py-40 md:px-12">
          <div className="mx-auto max-w-2xl flex-shrink-0 lg:mx-0 lg:max-w-xl lg:pt-8">
            {/* <Image className='w-64' src={logoWhite}></Image> */}
            <h2 className="mt-10 font-trajanPro tracking-tight text-5xl text-white">
              Get directly in touch with us
            </h2>
            <div className="mt-6 p leading-8 text-white flex flex-col gap-2">
              <p className="text-xl text-teracotta-600">Address</p>
              <p className="font-bold">CALLE MINERVA MIRABAL # 4</p>
              <p className="font-bold">57000 SOSÚA Contact</p>
              <p className="text-xl text-teracotta-600">Contact</p>
              <a className="font-bold" href="mailto:info@instyleresidences.com">info@instyleresidences.com</a>
              <a className="font-bold" href="tel:+1 809 383 4991">+1 809 383 4991</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
